import { unwrap, type MeOut } from "@sagot/api-client";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { queryKeys } from "../lib/query-keys";
import { useApi, useSession } from "./session-provider";

/** `GET /v1/me`: the user + workspace memberships (drives guards and the workspace switcher). */
export function useMe(): UseQueryResult<MeOut> {
  const api = useApi();
  const session = useSession();
  return useQuery({
    queryKey: queryKeys.me,
    queryFn: () => unwrap(api.GET("/v1/me")),
    enabled: session.status === "authenticated",
    staleTime: 60_000,
  });
}
